import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-callouts',
  templateUrl: './callouts.component.html',
  styleUrls: ['./callouts.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CalloutsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/callouts/callouts.component.ts